var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0C6.71371 0 0 6.71371 0 15C0 23.2863 6.71371 30 15 30C23.2863 30 30 23.2863 30 15C30 6.71371 23.2863 0 15 0ZM15 5.80645C17.9395 5.80645 20.3226 8.18952 20.3226 11.129C20.3226 14.0685 17.9395 16.4516 15 16.4516C12.0605 16.4516 9.67742 14.0685 9.67742 11.129C9.67742 8.18952 12.0605 5.80645 15 5.80645ZM15 26.6129C11.4496 26.6129 8.26815 25.004 6.13911 22.4879C7.27621 20.3468 9.50202 18.871 12.0968 18.871C12.2419 18.871 12.3871 18.8952 12.5262 18.9375C13.3125 19.1915 14.1351 19.3548 15 19.3548C15.8649 19.3548 16.6935 19.1915 17.4738 18.9375C17.6129 18.8952 17.7581 18.871 17.9032 18.871C20.498 18.871 22.7238 20.3468 23.8609 22.4879C21.7319 25.004 18.5504 26.6129 15 26.6129Z",
    fill: "#2E0F59"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.23b9f2e23302cfe4687e745a9154ce78.svg";
export { ForwardRef as ReactComponent };